
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#2FB95E"}}),_c('g',{attrs:{"clip-path":"url(#clip0_3173_579)","fill":"#fff"}},[_c('path',{attrs:{"d":"M15.482 17.418a.59.59 0 100-1.18.59.59 0 000 1.18zM27.336 12.75c-.763 0-1.406.514-1.602 1.214h-.749a.45.45 0 100 .9h.749a1.665 1.665 0 101.602-2.114zM27.36 16.62c-.433 0-.818.206-1.062.526-.13.151-.585.64-1.183.823-.653.198-1.316-.145-1.32-.146a.583.583 0 00-.79.234c-.154.283-.035.615.235.79.566.37 1.706.392 2.214.237.205-.062.396-.145.571-.24v2.847c0 .428.203.81.517 1.054v5.22a.819.819 0 001.637 0v-5.22c.314-.244.516-.626.516-1.054v-3.737c0-.737-.597-1.335-1.335-1.335z"}}),_c('path',{attrs:{"d":"M23.489 17.35c.459 0 .624.255 1.064.255.248 0 .538-.09.538-.222v-.946a.599.599 0 00-.599-.599h-1.717v.781a.102.102 0 01-.103.103h-.49a.102.102 0 01-.102-.103v-.78h-1.718a.599.599 0 00-.598.598v4.13c0 .33.268.598.598.598h4.13c.33 0 .599-.268.599-.598v-.823a.103.103 0 00-.036-.077.11.11 0 00-.08-.024c-1.945.156-2.835-.88-2.389-1.756.171-.335.526-.537.903-.537zM19.452 23.213h-.829V9.829a.614.614 0 00-.614-.614h-7.157a.614.614 0 00-.614.614v13.384H9.41a.41.41 0 00-.409.41v1.449c0 .226.183.41.41.41h10.042a.41.41 0 00.41-.41v-1.45a.41.41 0 00-.41-.409zm-7.986-12.77h5.93v12.77h-5.93v-12.77z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3173_579"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9 9)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    